exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "nav li#sprache {\n  background-color: gray; }\n", ""]);

